
jQuery(document).ready(function(){
  if (jQuery('.fade_section').length) {
      var current = 0;
      var num_options = jQuery('.fade_section').length;
      var freq = 3000;
      var fade_element_array = jQuery('.fade_section');
      var fadeoption = jQuery('.fadeoption');

      function fadein(x) {
          fade_element_array.eq(x).stop().fadeIn(500);
      }

      function fadeout(x) {
          fade_element_array.eq(x).stop().fadeOut(500);
      }

      function fade() {
          fadeout(current);
          current = current + 1;
          if (current >= num_options) {
              current = 0;
          }
          fadein(current);
          console.log("fading " + current);
          if (current == 2){
            fadeoption.stop().fadeOut(500);
          } else {
            fadeoption.stop().fadeIn(500);
          }
      }
      setInterval(fade, freq);
  }
});